const TARGET_WIDTH = 300;
const TARGET_HEIGHT = 400;
const MAX_BYTES = 200 * 1024;
const JPEG_QUALITY = 0.85;
const MIN_JPEG_QUALITY = 0.35;
const QUALITY_STEP = 0.08;
const ALLOWED_MIME_TYPES = ["image/png", "image/jpeg", "image/jpg"];

function isAllowedMimeType(mimeType) {
  return ALLOWED_MIME_TYPES.indexOf(mimeType) >= 0;
}

function loadImageFromFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error("IMAGE_LOAD_FAILED"));
      image.src = reader.result;
    };

    reader.onerror = () => reject(new Error("FILE_READ_FAILED"));
    reader.readAsDataURL(file);
  });
}

function getCoverCrop(sourceWidth, sourceHeight) {
  const sourceRatio = sourceWidth / sourceHeight;
  const targetRatio = TARGET_WIDTH / TARGET_HEIGHT;

  if (sourceRatio > targetRatio) {
    const cropWidth = sourceHeight * targetRatio;
    return {
      sx: (sourceWidth - cropWidth) / 2,
      sy: 0,
      sw: cropWidth,
      sh: sourceHeight
    };
  }

  const cropHeight = sourceWidth / targetRatio;
  return {
    sx: 0,
    sy: (sourceHeight - cropHeight) / 2,
    sw: sourceWidth,
    sh: cropHeight
  };
}

function canvasToBlob(canvas, mimeType, quality) {
  return new Promise((resolve, reject) => {
    const callback = blob => {
      if (!blob) {
        reject(new Error("BLOB_CONVERSION_FAILED"));
        return;
      }
      resolve(blob);
    };

    if (typeof quality === "number") {
      canvas.toBlob(callback, mimeType, quality);
    } else {
      canvas.toBlob(callback, mimeType);
    }
  });
}

function buildOutputFileName(originalName, mimeType) {
  const extension = mimeType === "image/png" ? "png" : "jpg";
  const baseName =
    typeof originalName === "string" && originalName.trim()
      ? originalName.replace(/\.[^.]+$/, "")
      : "promotional-image";

  return `${baseName}.${extension}`;
}

/**
 * Compacta imagem promocional para 300x400 e no máximo 200KB.
 * Aceita PNG/JPG/JPEG. Preferência: manter PNG se couber no limite;
 * caso contrário, converte para JPEG e reduz qualidade progressivamente.
 */
export async function compressPromotionalImage(file) {
  if (!file || !isAllowedMimeType(file.type)) {
    throw new Error("FILE_EXTENSION_NOT_ALLOWED_PNG_JPG_JPEG");
  }

  const image = await loadImageFromFile(file);
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  if (!context) {
    throw new Error("CANVAS_CONTEXT_UNAVAILABLE");
  }

  const crop = getCoverCrop(image.width, image.height);
  canvas.width = TARGET_WIDTH;
  canvas.height = TARGET_HEIGHT;
  context.clearRect(0, 0, TARGET_WIDTH, TARGET_HEIGHT);
  context.drawImage(
    image,
    crop.sx,
    crop.sy,
    crop.sw,
    crop.sh,
    0,
    0,
    TARGET_WIDTH,
    TARGET_HEIGHT
  );

  let blob = null;
  let mimeType = "image/jpeg";

  if (file.type === "image/png") {
    const pngBlob = await canvasToBlob(canvas, "image/png");
    if (pngBlob.size <= MAX_BYTES) {
      blob = pngBlob;
      mimeType = "image/png";
    }
  }

  if (!blob) {
    let quality = JPEG_QUALITY;

    while (true) {
      const jpegBlob = await canvasToBlob(canvas, "image/jpeg", quality);

      if (jpegBlob.size <= MAX_BYTES) {
        blob = jpegBlob;
        mimeType = "image/jpeg";
        break;
      }

      if (quality <= MIN_JPEG_QUALITY) {
        throw new Error("IMAGE_TOO_LARGE_FOR_LIMIT");
      }

      quality = Math.max(MIN_JPEG_QUALITY, quality - QUALITY_STEP);
    }
  }

  const outputFile = new File([blob], buildOutputFileName(file.name, mimeType), {
    type: mimeType,
    lastModified: Date.now()
  });

  // console.log(
  //   "[promotionalImage] compressed",
  //   JSON.stringify({
  //     originalName: file.name,
  //     originalType: file.type,
  //     originalBytes: file.size,
  //     originalWidth: image.width,
  //     originalHeight: image.height,
  //     outputName: outputFile.name,
  //     outputType: outputFile.type,
  //     outputBytes: outputFile.size,
  //     width: TARGET_WIDTH,
  //     height: TARGET_HEIGHT
  //   })
  // );

  return outputFile;
}
